// replace image on change mats type inputs

function evamatsInitProductConfigEarly() {
  // Cache DOM elements
  const productContainer = document.querySelector('.product.config_container');
  const popupContainer = document.querySelector('.application_form__content.config_container');

  if (!productContainer && !popupContainer) return;

  if (productContainer && productContainer.dataset.type === 'corners') {
    document.addEventListener('change', function (event) {
      if (!event.target.closest('.product.config_container .lip__field[data-type="matPattern"], .product.config_container .lip__field[data-type="matColor"], .product.config_container .lip__field[data-type="trimColor"]')) return;
      productContainer.querySelectorAll('.product__config_image--desktop img, .product__config_image--mobile_image').forEach(function (img) {
        img.style.setProperty('transition', 'none', 'important');
        img.style.setProperty('visibility', 'hidden', 'important');
      });
    }, true);
  }

  // Initialize auto type
  let initialautoType, autoType;
  const productElement = document.querySelector('.product');
  
  if (productElement) {
    initialautoType = productElement.dataset.type;
    autoType = productElement.dataset.type;
  } else {
    autoType = '5os';
  }

  // Auto type normalization
  const basePath = "https://cdn.shopify.com/s/files/1/0734/7988/1010/files/";
  const typeMapping = {
    '7os': '5os', 'pickup': '5os', 'pickup2kabina': '5os', '2os': '5os',
    'van_maly': '5os', 'electro': '5os', 'custom': '5os', 'electro_7os': '5os',
    'van_duzy': 'VAN', 'camper': 'VAN', 'tractor': 'VAN', 'bus_solid': 'VAN',
    'van_duzy_solid': 'VAN', 'van_duzy_solid_2_row': 'VAN',
    'van_duzy_separate': 'bus', 'van_duzy_separate_2_row': 'bus',
    'minivan_mini': 'minivan'
  };

  function withCdnWidth(src, width) {
    if (!src) return src;
    try {
      const url = new URL(src, window.location.href);
      if (/\/cdn\/shop\/files\//.test(url.pathname) || /cdn\.shopify\.com$/.test(url.hostname)) {
        url.searchParams.set('width', String(width));
      }
      return url.href;
    } catch (_) {
      return src;
    }
  }
  autoType = typeMapping[autoType] || autoType;

  // Pattern class mapping
  const patternClassMap = {
    'romby': 'diamonds',
    'plastry miodu': 'honey',
    'krople': 'drop'
  };

  const typeCustomPrices = {
    noEdge: [450, 450, 710, 550, 910],
    withEdge: [550, 550, 910, 550, 1210]
  };

  // Для продукта с несколькими кузовами (data-type="5os, 7os"): тип для картинки берём из выбора в шаге year
  function getEffectiveBodyTypeForImage() {
    const productEl = document.querySelector('.product');
    const raw = productEl ? (productEl.dataset.type || '').trim() : '';
    if (!raw) return null;
    if (raw.indexOf(',') >= 0) {
      const yearWr = document.querySelector('[data-dropdown="year"]');
      const radio = yearWr && yearWr.querySelector('input[name="properties[Typ nadwozia]"]:checked');
      if (radio) {
        let t = (radio.getAttribute('data-body-type') || radio.value || '').trim().toLowerCase();
        if (t.indexOf('7os') >= 0) return '7os';
        if (t.indexOf('5os') >= 0) return '5os';
      }
      return raw.split(',')[0].trim();
    }
    return raw;
  }

  // Get current options from container
  function getCurrentOptions(container) {
    const matTypeElement = container.querySelector('.product-form__input[data-name="mats_type"] input:checked');
    const matType = matTypeElement ? matTypeElement.dataset.name.toLowerCase().replace(/\s+/g, '-') : 'classic';
    let matPattern = container.querySelector('.lip__field[data-type="matPattern"] input:checked')?.dataset.value;
    const matColor = container.querySelector('.lip__field[data-type="matColor"] input:checked')?.dataset.value;
    let edgeColor = container.querySelector('.lip__field[data-type="trimColor"] input:checked')?.dataset.value;
    
    if (matPattern !== 'drop') {
      if (edgeColor === 'darkblue') edgeColor = 'blue';
      else if (edgeColor === 'blue') edgeColor = 'darkblue';
    }
    
    return { matType, matPattern, matColor, edgeColor };
  }

  // Update mat image
  function updateMatImage(container) {
    let { matType, matPattern, matColor, edgeColor } = getCurrentOptions(container);
    let typeForImage = autoType;
    if (!container.classList.contains('application_form__content')) {
      const effective = getEffectiveBodyTypeForImage();
      typeForImage = effective ? (typeMapping[effective] || effective) : autoType;
    }
    // Krople (drop): real krople renders exist ONLY for the 5os image base (4 mat colours x 15
    // trims, all present). For any other body-type reuse those existing krople images so the
    // option previews actual krople cells instead of 404-ing. 5os itself is untouched.
    // Corners/organizers have their own krople renders, cropped to just the mat corner
    // (corners-krople-<colour>-<trim>). Named drop2 because the first upload under
    // corners-drop-* is stuck in the CDN cache (max-age 1 year).
    // 13.10.2026: tir, bus, VAN and minivan have their own honey / drop renders (same file names as the 5os ones), so there is no redirect to the 5os image or to diamonds any more.
    if (matPattern === 'drop' && typeForImage === 'corners') {
      matPattern = 'krople';
    }

    /* Product-page previews use the transparent/no-background render (suffix "1").
       The quote popup is a separate presentation surface and must always use the
       original white-background render so the mat is not shown as a rough crop. */
    const isQuotePopup = container.classList.contains('application_form__content');
    const bgSuffix = isQuotePopup ? '' : '1';
    const cornersPattern = matPattern === 'drop' ? 'krople' : matPattern;
    // Krople renders for corners keep the original filename without the no-background "1" suffix.
    const cornersBgSuffix = cornersPattern === 'krople' ? '' : bgSuffix;
    // Zestawy zdjęć narożników: nazwa pliku = wzór + numer zestawu. Nowy zestaw = nowe nazwy plików (CDN trzyma stare pliki rok).
    const CORNERS_SETS = { krople: 'krople3', diamonds: 'diamonds4', honey: 'honey4' };
    const cornersFile = CORNERS_SETS[cornersPattern] || cornersPattern;
    const isCornersSet = (url) => Object.values(CORNERS_SETS).some((set) => url.includes('/corners-' + set + '-'));
    let imageUrl;
    if (typeForImage === 'corners') {
      // Corners / EVA organizers: no mats_type segment in CDN filename
      imageUrl = `${basePath}corners-${cornersFile}-${matColor}-${edgeColor}${cornersBgSuffix}.webp`;
    } else if (container.classList.contains('application_form__content')) {
      imageUrl = document.body.classList.contains('template_zamowienie-indywidualne')
        ? `${basePath}corners-${cornersFile}-${matColor}-${edgeColor}${cornersBgSuffix}.webp`
        : `${basePath}5os-${matType ? matType + '-' : ''}${matPattern}-${matColor}-${edgeColor}${bgSuffix}.webp`;
    } else {
      /* Segment mats_type (np. "classic") wystepuje w nazwach plikow na CDN WYLACZNIE
         dla bazy 5os. Pozostale bazy - minivan, VAN, bus, tir - sa wgrane bez niego
         (minivan-diamonds-black-black1.webp, nie minivan-classic-...). Doklejanie go
         wszystkim dawalo 404 i pusty podglad na kazdym nadwoziu spoza grupy 5os. */
      const matSeg = (typeForImage === '5os' && matType) ? matType + '-' : '';
      imageUrl = `${basePath}${typeForImage}-${matSeg}${matPattern}-${matColor}-${edgeColor}${bgSuffix}.webp`;
    }

    imageUrl = withCdnWidth(imageUrl, 900);

    // Keep the hidden quote popup dormant until somebody opens it.
    const popupOverlay = container.closest('#popupOverlayApplicationForm');
    const deferPopup = container.classList.contains('application_form__content') &&
      popupOverlay &&
      !popupOverlay.classList.contains('show') &&
      !popupOverlay.classList.contains('evm-individual-form');

    /* Gdyby dla ktorejs bazy zabraklo renderu, pokazujemy wersje 5os zamiast pustego
       kwadratu: ksztalt komorek i kolory sa te same, rozni sie tylko obrys kompletu. */
    const zapasowyUrl = withCdnWidth(
      `${basePath}5os-${matType ? matType + '-' : ''}${matPattern}-${matColor}-${edgeColor}${bgSuffix}.webp`, 900);

    function setPreviewSource(img) {
      if (deferPopup) {
        img.dataset.evmPendingSrc = imageUrl;
        return;
      }
      img.removeAttribute('data-evm-pending-src');
      if (imageUrl.includes('/corners-')) {
        if (img.dataset.evmPreviewTarget === imageUrl && img.src === imageUrl && img.complete && img.naturalWidth > 0) {
          img.style.setProperty('visibility', 'visible', 'important');
          return;
        }
        if (img.dataset.evmPreviewLoading === imageUrl) return;
        img.dataset.evmPreviewTarget = imageUrl;
        img.dataset.evmPreviewLoading = imageUrl;
        img.style.setProperty('transition', 'none', 'important');
        img.style.setProperty('visibility', 'hidden', 'important');
        const probe = new Image();
        probe.decoding = 'async';
        probe.onload = async function () {
          try { if (probe.decode) await probe.decode(); } catch (_) {}
          if (img.dataset.evmPreviewTarget !== imageUrl) return;
          img.onload = function () {
            if (img.dataset.evmPreviewTarget === imageUrl) {
              img.dataset.evmPreviewLoading = '';
              img.style.setProperty('visibility', 'visible', 'important');
            }
          };
          img.onerror = function () {
            if (img.dataset.evmPreviewTarget !== imageUrl) return;
            img.dataset.evmPreviewLoading = '';
            if (isCornersSet(imageUrl)) return;
            img.onload = function () { img.style.setProperty('visibility', 'visible', 'important'); };
            img.src = zapasowyUrl;
          };
          img.src = imageUrl;
          if (img.complete && img.naturalWidth > 0) {
            img.dataset.evmPreviewLoading = '';
            img.style.setProperty('visibility', 'visible', 'important');
          }
        };
        probe.onerror = function () {
          if (img.dataset.evmPreviewTarget !== imageUrl) return;
          img.dataset.evmPreviewLoading = '';
          if (isCornersSet(imageUrl)) return;
          img.onload = function () { img.style.setProperty('visibility', 'visible', 'important'); };
          img.src = zapasowyUrl;
        };
        probe.src = imageUrl;
        return;
      }
      img.dataset.evmFallbackSrc = zapasowyUrl;
      if (img.dataset.evmFallbackBound !== '1') {
        img.dataset.evmFallbackBound = '1';
        img.addEventListener('error', function () {
          const zapas = img.dataset.evmFallbackSrc;
          if (!zapas || img.src === zapas) return;   // brak zapasu albo juz go probowalismy
          img.src = zapas;
        });
      }
      if (img.src !== imageUrl) img.src = imageUrl;
    }

    // Always keep both visible previews in sync.
    const desktopImgs = container.querySelectorAll('.product__config_image--desktop img');
    const mobileImgs = container.querySelectorAll('.product__config_image--mobile_image');
    desktopImgs.forEach(setPreviewSource);
    mobileImgs.forEach(setPreviewSource);
  }
  window.evmUpdateMatImage = updateMatImage;

  // Update lip title values
  const updateLipTitleValue = () => {
    // Update radio button fields
    document.querySelectorAll('.lip__field').forEach(field => {
      const inputChecked = field.querySelector('input:checked');
      if (!inputChecked) return;

      const value = inputChecked.dataset.title;
      const titleValueElement = field.querySelector('.lip__title_value');
      if (titleValueElement) titleValueElement.textContent = value;

      // Update properties
      const selectedRodzaj = document.querySelector('input[name="Rodzaj dywaników"]:checked');
      const selectedZestaw = document.querySelector('input[name="Zestaw"]:checked');
      const selectedRozmiar = document.querySelector('input[name="Rozmiar"]:checked');

      const rodzajProperty = document.querySelector('[name="properties[Rodzaj dywaników_]"]');
      const zestawProperty = document.querySelector('[name="properties[Zestaw_]"]');
      const rozmiarProperty = document.querySelector('[name="properties[Rozmiar_]"]');
      
      if (rodzajProperty && selectedRodzaj && selectedZestaw) {
        rodzajProperty.value = selectedRodzaj.value;
        zestawProperty.value = selectedZestaw.value;
      }
      if (rozmiarProperty && selectedRozmiar) {
        rozmiarProperty.value = selectedRozmiar.value;
      }

      // Handle custom type pricing
      if (initialautoType === 'custom' && selectedRodzaj && selectedZestaw) {
        const zestawField = document.querySelector('[data-name="Zestaw"]');
        const zestawValue = zestawField?.querySelector('input:checked')?.dataset.title;
        const rodzajValue = selectedRodzaj.dataset.title;
        const zestawIndex = Array.from(selectedZestaw.closest('fieldset').querySelectorAll('input')).indexOf(selectedZestaw);
        
        let price = null;
        if (rodzajValue === '3D BEZ RANTÓW') price = typeCustomPrices.noEdge[zestawIndex];
        else if (rodzajValue === '3D Z RANTAMI') price = typeCustomPrices.withEdge[zestawIndex];
        
        const zestawTitleValue = zestawField?.querySelector('.lip__title_value');
        /* 28.09.2026: tabela typeCustomPrices jest nieaktualna (stary cennik) i przesunięta o jedną pozycję wobec listy
           popupu — to ona pisała „Dywanik Kierowcy 450 zł” w popupie „Wyceń zestaw” na zamówieniu indywidualnym.
           Ceny w popupie liczy teraz application-form-ui.js z wariantów Shopify, więc popupu tu nie ruszamy. */
        if (zestawTitleValue && price !== null && !zestawField.closest('#popupOverlayApplicationForm')) {
          zestawTitleValue.textContent = `${zestawValue} ${price} zł`;
        }
      }
    });

    // Update select elements
    document.querySelectorAll('select').forEach(select => {
      if (!select.value) return;
      const fieldset = select.closest('fieldset');
      const titleValueElement = fieldset?.querySelector('.lip__title_value');
      if (titleValueElement) {
        titleValueElement.textContent = select.options[select.selectedIndex].text;
      }
    });

    // Update text inputs and textareas in .lip__field (Marka samochodu, Model samochodu, Pojazd, etc.)
    document.querySelectorAll('.lip__field input[type="text"], .lip__field textarea').forEach(input => {
      const field = input.closest('.lip__field');
      const titleValueEl = field?.querySelector('.lip__title_value');
      if (titleValueEl) titleValueEl.textContent = input.value.trim();
    });
  };

  function resetMatColorForPattern(patternClass, matColorField, container) {
    if (!patternClass || !matColorField) return;

    ['honey_active', 'diamonds_active', 'drop_active'].forEach(function (cls) {
      matColorField.classList.remove(cls);
    });
    matColorField.classList.add(patternClass + '_active');

    var checkedColor = matColorField.querySelector('input[type="radio"]:checked');
    if (checkedColor) {
      var currentItem = checkedColor.closest('.lip__item');
      if (!currentItem || !currentItem.classList.contains(patternClass)) {
        checkedColor.checked = false;
      }
    }

    // While persisted config is restoring, keep filter only — do not force first color.
    if (!matColorField.querySelector('input[type="radio"]:checked') && !window.__evmMatCfgRestoring) {
      var firstValid = matColorField.querySelector('.lip__item.' + patternClass + ' input[type="radio"]');
      if (firstValid) {
        firstValid.checked = true;
      }
    }

    var titleValue = matColorField.querySelector('.lip__title_value');
    var selectedColor = matColorField.querySelector('input[type="radio"]:checked');
    if (titleValue) {
      titleValue.textContent = selectedColor ? (selectedColor.dataset.title || '') : '';
    }

    if (container) {
      updateSelectedValueText(container);
    }
  }

  // Handle pattern change
  function handlePatternChange(input, parentContainer) {
    var patternClass = patternClassMap[input.value];
    if (!patternClass) return;

    var matColorField = parentContainer.querySelector('.lip__field[data-type="matColor"]');
    resetMatColorForPattern(patternClass, matColorField, parentContainer);
  }

  // EVENT DELEGATION - Single event listener instead of hundreds
  document.addEventListener('change', (e) => {
    const target = e.target;
    
    // Handle radio buttons
    if (target.type === 'radio' && 
        (target.closest('.product-form__input') || target.closest('.lip__field'))) {
      
      const parentContainer = target.closest('.config_container');
      if (!parentContainer) return;
      
      if (target.closest('.product-form__input[data-name="mats_type"]') ||
          target.closest('.product-form__input[data-name="mats_set"]') ||
          target.closest('.lip__field[data-type="matColor"]') ||
          target.closest('.lip__field[data-type="trimColor"]')) {
        updateSelectedValueText(parentContainer);
      }

      if (target.closest('.lip__field[data-type="matPattern"]')) {
        handlePatternChange(target, parentContainer);
      }

      updateMatImage(parentContainer);
      updateLipTitleValue();
    }
    
    // Handle select elements
    if (target.tagName === 'SELECT') {
      updateLipTitleValue();
    }

    // Handle text inputs and textareas in .lip__field (Marka/Model samochodu, Pojazd)
    if (target.matches('input[type="text"], textarea') && target.closest('.lip__field')) {
      updateLipTitleValue();
    }
  }, true); // Use capture phase for better performance

  // Live update .lip__title_value while typing in text fields
  document.addEventListener('input', (e) => {
    if (e.target.matches('input[type="text"], textarea') && e.target.closest('.lip__field')) {
      updateLipTitleValue();
    }
  }, true);

  // Initialize
  [productContainer, popupContainer].forEach(container => {
    if (container) {
      updateMatImage(container);
      restoreMatPattern(container);
    }
  });
  updateLipTitleValue();

  // Restore mat pattern on page load/back
  function restoreMatPattern(container) {
    if (!container) return;

    setTimeout(() => {
      const checkedPattern = container.querySelector('.lip__field[data-type="matPattern"] input:checked');
      if (!checkedPattern) return;

      const patternClass = patternClassMap[checkedPattern.value];
      if (!patternClass) return;

      const matColorField = container.querySelector('.lip__field[data-type="matColor"]');
      resetMatColorForPattern(patternClass, matColorField, container);
      updateMatImage(container);
      updateLipTitleValue();
    }, 50);
  }

  // Page show event
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    [productContainer, popupContainer].forEach(container => {
      if (container) restoreMatPattern(container);
    });
  });

  function prettyPreviewText(txt) {
    var s = (txt || '').replace(/\s+/g, ' ').trim();
    if (!s) return s;
    var isEnglish = /^en(?:-|$)/i.test(document.documentElement.lang || '');
    s = s.replace(/^rodzaj\s+dywanik[oó]w:\s*/i, '').replace(/^zestaw:\s*/i, '');
    if (/^3d\s+bez\s+rant/i.test(s)) return isEnglish ? '3D without raised edges' : '3D bez rantów';
    if (/^3d\s+z\s+rant/i.test(s)) return isEnglish ? '3D with raised edges' : '3D z rantami';
    if (/3\s*r(z[ąa]d|z[ęe]dy).+2\s*baga/i.test(s)) return isEnglish ? '3 rows + 2 trunk mats' : '3 rzędy + 2 bagażniki';
    s = s.replace(/\s*\([^)]*\)\s*$/, '');
    s = s.replace(/^kolor\s+materia[łl]u:\s*/i, '').replace(/^kolor\s+obszycia:\s*/i, '');
    if (isEnglish && window.EVM_EN_CONFIG && typeof window.EVM_EN_CONFIG.translate === 'function') {
      s = window.EVM_EN_CONFIG.translate(s) || s;
    }
    return s.toLowerCase().replace(/(^|[\s+/-])([a-ząćęłńóśźż])/g, function (_, p, c) {
      return p + c.toUpperCase();
    }).replace(/\s+\+\s+/g, ' + ');
  }

  function usablePreviewImg(src) {
    if (!src || src.indexOf('data:') === 0) return '';
    if (/no-image|shopifycloud\/storefront/i.test(src)) return '';
    return src;
  }

  function checkedPreviewInfo(container, fieldSelector) {
    const field = container.querySelector(fieldSelector);
    const input = field && field.querySelector('input:checked');
    if (!input) return { txt: '', img: '' };
    const label = input.closest('label') ||
      (input.id ? container.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null) ||
      input.nextElementSibling;
    let imgEl = null;
    if (label && label.querySelector) imgEl = label.querySelector('img');
    else if (input.nextElementSibling && input.nextElementSibling.tagName === 'IMG') imgEl = input.nextElementSibling;
    const img = usablePreviewImg(
      (imgEl && (imgEl.getAttribute('data-evm-src') || imgEl.getAttribute('src') || imgEl.currentSrc || imgEl.src)) || ''
    );
    return {
      txt: input.dataset.title || input.value || '',
      img: img
    };
  }

  // Chip text for unified preview (desktop gallery + mobile popup)
  function updateSelectedValueText(container) {
    const preview = document.querySelector('.product__config_image--main.product__config_image--mobile');
    if (!preview) return;

    function syncChip(sel, info, withImg) {
      const chip = preview.querySelector(`.product__config_image_selected_value${sel}`);
      if (!chip || !info || !info.txt) return;
      let span = chip.querySelector('span');
      if (!span) {
        span = document.createElement('span');
        chip.appendChild(span);
      }
      span.textContent = prettyPreviewText(info.txt);
      const longLimit = /matColor|trimColor/.test(sel) ? 8 : (/matPattern/.test(sel) ? 14 : 22);
      chip.classList.toggle('evm-chip-long', span.textContent.length > longLimit);

      if (withImg && info.img) {
        let im = chip.querySelector('img.evm-pv-chip-img') || chip.querySelector('img');
        if (!im) {
          im = document.createElement('img');
          im.alt = '';
          chip.insertBefore(im, span);
        }
        Array.prototype.slice.call(chip.querySelectorAll('img')).forEach(function (other) {
          if (other !== im) other.parentNode.removeChild(other);
        });
        im.classList.add('evm-pv-chip-img');
        if (im.src !== info.img) im.src = info.img;
      }
    }

    const typeInfo = checkedPreviewInfo(container, '.product-form__input[data-name="mats_type"]');
    const setInfo = checkedPreviewInfo(container, '.product-form__input[data-name="mats_set"]');
    const patInfo = checkedPreviewInfo(container, 'fieldset[data-type="matPattern"]');
    const matColorInfo = checkedPreviewInfo(container, 'fieldset[data-type="matColor"]');
    const trimColorInfo = checkedPreviewInfo(container, 'fieldset[data-type="trimColor"]');

    syncChip('[data-name="mats_type"]', typeInfo, true);
    syncChip('[data-name="mats_set"]', setInfo, true);
    syncChip('[data-type="matPattern"]', { txt: patInfo.txt || (/^en(?:-|$)/i.test(document.documentElement.lang || '') ? 'Diamonds' : 'Diamenty'), img: patInfo.img }, true);
    syncChip('[data-type="matColor"]', matColorInfo, true);
    syncChip('[data-type="trimColor"]', trimColorInfo, true);

    const typeText = (typeInfo.txt || '').toLowerCase();
    preview.classList.toggle('evm-preview-bez-rantow', /bez\s+rant/.test(typeText));
    preview.classList.toggle('evm-preview-z-rantami', /z\s+rant|rantami/.test(typeText) && !/bez\s+rant/.test(typeText));
    const patText = (patInfo.txt || '').toLowerCase();
    preview.classList.toggle('evm-pattern-krople', /kropl/.test(patText));
    preview.classList.toggle('evm-pattern-romby', /romb/.test(patText));
    preview.classList.toggle('evm-pattern-plastry', /plastr|miod/.test(patText));
  }

  window.evmSyncConfigChips = function () {
    if (productContainer) updateSelectedValueText(productContainer);
    if (popupContainer) updateSelectedValueText(popupContainer);
  };

  if (productContainer) updateSelectedValueText(productContainer);
  if (popupContainer) updateSelectedValueText(popupContainer);

  const applicationPopup = document.querySelector('#popupOverlayApplicationForm');
  if (applicationPopup && popupContainer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (applicationPopup.classList.contains('show')) updateMatImage(popupContainer);
    }).observe(applicationPopup, { attributes: true, attributeFilter: ['class'] });
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', evamatsInitProductConfigEarly);
} else {
  evamatsInitProductConfigEarly();
}

// Unified preview card: desktop under gallery, mobile sticky under header/tabs.
// Same chrome (chips + frame); only placement of the mat image differs by viewport.
let configImageInitialized = false;

function initConfigImage() {
  if (configImageInitialized) return;
  configImageInitialized = true;

  const configImage = document.querySelector('.product__config_image--main.product__config_image--mobile');
  const setStep = document.querySelector('[data-dropdown="mats_set_type"]');
  const colorsStep = document.querySelector('[data-dropdown="mat_patterns_colors"]');
  const heelStep = document.querySelector('.product__dropdown_wr--heel');
  if (!configImage || (!setStep && !colorsStep && !heelStep)) return;

  const desktopSlot = document.querySelector('.product__config_image--desktop');
  const homeParent = configImage.parentNode;
  const homeNext = configImage.nextSibling;
  const mq = window.matchMedia('(max-width: 1023px)');
  const expandBtnEl = configImage.querySelector('.evm-pv-expand');
  const collapseBtnEl = configImage.querySelector('.evm-pv-collapse');
  const isEnglish = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const showPreviewLabel = isEnglish ? 'Show preview' : 'Pokaż podgląd';
  const hidePreviewLabel = isEnglish ? 'Hide preview' : 'Ukryj podgląd';
  let previewExpanded = false;
  let activePreviewStep = null;

  configImage.classList.add('evm-preview');
  configImage.classList.remove('is-fixed', 'fixed_hidden', 'is-preview-popup', 'is-collapsed');
  if (typeof window.evmSyncConfigChips === 'function') window.evmSyncConfigChips();
  configImage.querySelectorAll('.evm-pv-note, .evm-pv-expand').forEach(function (n) {
    n.hidden = false;
    n.removeAttribute('hidden');
  });

  function getOpenPreviewStep() {
    if (setStep && setStep.classList.contains('open')) return setStep;
    if (colorsStep && colorsStep.classList.contains('open')) return colorsStep;
    if (heelStep && heelStep.classList.contains('open')) return heelStep;
    return null;
  }

  function previewStepOpen() {
    return !!getOpenPreviewStep();
  }

  function placeInHome() {
    if (homeParent && configImage.parentNode !== homeParent) {
      homeParent.insertBefore(configImage, homeNext);
    }
  }

  function placeStickyMobile() {
    const progress = document.querySelector('.evm-progress');
    const cfgCard = document.querySelector('.evm-cfg-card');
    const cornersCard = document.querySelector(
      '.evm-corners-shell .evm-corners-card, .evm-corners-shell [data-dropdown="mat_patterns_colors"]'
    );
    const anchor = progress || cfgCard;
    if (anchor && anchor.parentNode) {
      if (configImage.previousElementSibling !== anchor) {
        anchor.parentNode.insertBefore(configImage, anchor.nextSibling);
      }
      return;
    }
    // Corners: stick above the white config card (same role as progress on mats)
    if (cornersCard && cornersCard.parentNode) {
      if (configImage.nextElementSibling !== cornersCard) {
        cornersCard.parentNode.insertBefore(configImage, cornersCard);
      }
      return;
    }
    placeInHome();
  }

  function syncExpandBtn() {
    var noteEl = configImage.querySelector('.evm-pv-note');
    const isPreviewStepOpen = previewStepOpen();
    if (expandBtnEl) {
      expandBtnEl.textContent = previewExpanded ? hidePreviewLabel : showPreviewLabel;
      expandBtnEl.hidden = !isPreviewStepOpen;
      if (isPreviewStepOpen) expandBtnEl.removeAttribute('hidden');
      else expandBtnEl.setAttribute('hidden', '');
      expandBtnEl.classList.add('evm-pv-expand--show');
      expandBtnEl.setAttribute('aria-expanded', previewExpanded ? 'true' : 'false');
    }
    if (collapseBtnEl) {
      collapseBtnEl.hidden = true;
      collapseBtnEl.setAttribute('hidden', '');
    }
    if (noteEl) {
      noteEl.hidden = !previewExpanded;
      if (previewExpanded) noteEl.removeAttribute('hidden');
      else noteEl.setAttribute('hidden', '');
    }
  }

  function syncPreviewUi() {
    const nextPreviewStep = getOpenPreviewStep();
    if (nextPreviewStep !== activePreviewStep) {
      previewExpanded = false;
      activePreviewStep = nextPreviewStep;
    }

    configImage.classList.remove('is-preview-popup', 'is-open', 'is-fixed', 'fixed_hidden', 'is-collapsed');

    if (!mq.matches) {
      previewExpanded = false;
      placeInHome();
      if (desktopSlot) desktopSlot.classList.remove('is-replaced-by-unified-preview');
      configImage.classList.remove('evm-preview-on', 'evm-preview-expanded', 'evm-preview-mat-on');
      syncExpandBtn();
      return;
    }

    if (desktopSlot) desktopSlot.classList.remove('is-replaced-by-unified-preview');

    if (!previewStepOpen()) {
      previewExpanded = false;
      configImage.classList.remove('evm-preview-on', 'evm-preview-expanded', 'evm-preview-mat-on');
      placeInHome();
      syncExpandBtn();
      return;
    }

    placeStickyMobile();
    configImage.classList.add('evm-preview-on');
    configImage.classList.toggle('evm-preview-mat-on', previewExpanded);
    configImage.classList.toggle('evm-preview-expanded', previewExpanded);
    syncExpandBtn();
  }

  let previewUiFrame = 0;
  function schedulePreviewUi() {
    if (previewUiFrame) return;
    previewUiFrame = window.requestAnimationFrame(() => {
      previewUiFrame = 0;
      syncPreviewUi();
    });
  }

  syncPreviewUi();
  window.addEventListener('resize', schedulePreviewUi, { passive: true });
  if (typeof mq.addEventListener === 'function') mq.addEventListener('change', schedulePreviewUi);
  else if (typeof mq.addListener === 'function') mq.addListener(schedulePreviewUi);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.product__dropdown_button') || e.target.closest('.product__dropdown_title')) {
      setTimeout(schedulePreviewUi, 80);
      setTimeout(schedulePreviewUi, 400);
    }

    const expandBtn = e.target.closest('.evm-pv-expand');
    if (expandBtn && configImage.contains(expandBtn)) {
      e.preventDefault();
      if (!previewStepOpen()) return;
      previewExpanded = !previewExpanded;
      syncPreviewUi();
      return;
    }
    const collapseBtn = e.target.closest('.evm-pv-collapse');
    if (collapseBtn && configImage.contains(collapseBtn)) {
      e.preventDefault();
      if (!previewStepOpen()) return;
      return;
    }
  }, true);

  [setStep, colorsStep, heelStep].forEach((el) => {
    if (!el) return;
    new MutationObserver(schedulePreviewUi).observe(el, {
      attributes: true,
      attributeFilter: ['class']
    });
  });

  const pvImg = configImage.querySelector('.product__config_image--mobile_image');
  const zoomBtn = configImage.querySelector('.evm-pv-zoom, .product__config_image_zoom');
  function getWhiteBackgroundPreview(src) {
    try {
      const url = new URL(src, window.location.href);
      url.searchParams.delete('width');
      url.pathname = url.pathname.replace(/1(\.webp)$/i, '$1');
      return url.href;
    } catch (_) {
      return src.replace(/1(\.webp)(?=\?|$)/i, '$1');
    }
  }
  function openLightbox(src) {
    if (!src || /1x1_0{4,}/.test(src)) return;
    let lb = document.querySelector('.product-config-lightbox');
    if (lb) lb.remove();
    lb = document.createElement('div');
    lb.className = 'product-config-lightbox';
    lb.innerHTML = '<div class="product-config-lightbox__in"><button type="button" class="product-config-lightbox__x" aria-label="Zamknij">&times;</button><img alt="Podgląd dywanika"></div>';
    const lightboxImg = lb.querySelector('img');
    let fullSizeSrc = src;
    try {
      const fullSizeUrl = new URL(src, window.location.href);
      fullSizeUrl.searchParams.delete('width');
      fullSizeSrc = fullSizeUrl.href;
    } catch (_) {}
    const whiteBackgroundSrc = getWhiteBackgroundPreview(fullSizeSrc);
    if (whiteBackgroundSrc !== fullSizeSrc) {
      lightboxImg.addEventListener('error', function useTransparentFallback() {
        lightboxImg.src = fullSizeSrc;
      }, { once: true });
    }
    lightboxImg.src = whiteBackgroundSrc;
    lb.addEventListener('click', () => lb.remove());
    document.body.appendChild(lb);
  }
  function zoomPreview(e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    if (!pvImg) return;
    openLightbox(pvImg.currentSrc || pvImg.src);
  }
  if (zoomBtn) zoomBtn.addEventListener('click', zoomPreview);
  if (pvImg) {
    pvImg.style.cursor = 'zoom-in';
    pvImg.addEventListener('click', zoomPreview);
  }
}

(function bootConfigImage() {
  const target = document.querySelector('.product__config_image--main.product__config_image--mobile');
  if (!target) return;
  function start() { initConfigImage(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
  // CRO builds .evm-progress / .evm-cfg-card after load — re-place sticky preview
  window.addEventListener('load', function () {
    setTimeout(function () {
      if (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 1023px)').matches) {
        const ev = new Event('resize');
        window.dispatchEvent(ev);
      }
    }, 300);
  });
})();


// Config steps - OPTIMIZED with event delegation
(() => {
  var formContainers = document.querySelectorAll('.config_container');
  if (formContainers.length === 0) {
    formContainers = Array.from(document.querySelectorAll('.product')).filter(function (p) {
      return p.querySelector('.product__dropdown_wr');
    });
  }
  if (formContainers.length === 0) return;

  formContainers.forEach(container => {
    if (!container.querySelector('.product__dropdown_wr')) return;

    container.querySelectorAll('fieldset .error-message').forEach(el => el.style.display = 'none');

    const faqWrappers = container.querySelectorAll('.product__dropdown_wr');

    function triggerFaq(element) {
      const wrapper = element.closest('.product__dropdown_wr');
      const inner = wrapper.querySelector('.product__dropdown_inner');

      faqWrappers.forEach(w => {
        if (w === wrapper) return;
        w.classList.remove('open');
        const innerOther = w.querySelector('.product__dropdown_inner');
        innerOther.classList.remove('open');
        if (innerOther.classList.contains('super_done')) {
          innerOther.classList.add('done');
        }
      });

      const isOpen = wrapper.classList.toggle('open');
      inner.classList.toggle('open', isOpen);
      inner.classList.toggle('done', !isOpen && inner.classList.contains('super_done'));
    }

    function validateStep(wrapper, showErrors = false) {
      let stepValid = true;
      const processedRadioGroups = new Set();
      const requiredElements = wrapper.querySelectorAll('input[required], select[required], textarea[required]');

      requiredElements.forEach(element => {
        if (!showErrors && !element.offsetParent) return;
        let valid = true;

        if (element.type === 'radio') {
          if (processedRadioGroups.has(element.name)) return;
          processedRadioGroups.add(element.name);
          valid = [...wrapper.querySelectorAll(`input[type="radio"][name="${element.name}"]`)]
            .some(radio => radio.checked);
        } else if (element.type === 'checkbox') {
          valid = element.checked;
        } else {
          valid = element.value.trim() !== '';
        }

        const fieldset = element.closest('fieldset');
        const errorMessage = fieldset ? fieldset.querySelector('.error-message') : null;
        if (errorMessage) {
          if (showErrors) {
            errorMessage.style.setProperty('display', !valid ? 'block' : 'none', 'important');
          } else if (valid) {
            errorMessage.style.setProperty('display', 'none', 'important');
          }
        }
        if (!valid) stepValid = false;
      });
      return stepValid;
    }

    function updateContinueButton(wrapper) {
      const continueBtn = wrapper.querySelector('.product__dropdown_button');
      if (!continueBtn) return;

      const isValid = validateStep(wrapper, false);
      // Не ставим disabled — иначе клик по кнопке не вызывает click, и error-message не показывается
      continueBtn.removeAttribute('disabled');
      continueBtn.classList.toggle('disabled-button', !isValid);
      continueBtn.setAttribute('aria-disabled', !isValid);
    }

    function revalidate(wrapper) {
      const inner = wrapper.querySelector('.product__dropdown_inner');
      const isValid = validateStep(wrapper, false);

      if (!isValid) {
        inner.classList.remove('super_done');
        wrapper.classList.remove('complete');
        setFollowingStepsDisabled(wrapper, true);
      }

      updateContinueButton(wrapper);
      if (container.querySelector('.application_form__next_button')) {
        updateNextButtonState(container);
      }
    }

    // Initialize buttons
    faqWrappers.forEach(wrapper => updateContinueButton(wrapper));

    // EVENT DELEGATION for all interactions
    container.addEventListener('input', (e) => {
      const wrapper = e.target.closest('.product__dropdown_wr');
      if (wrapper && e.target.matches('input[required], select[required], textarea[required]')) {
        revalidate(wrapper);
      }
    }, true);

    container.addEventListener('change', (e) => {
      const wrapper = e.target.closest('.product__dropdown_wr');
      if (wrapper && e.target.matches('input[required], select[required], textarea[required]')) {
        revalidate(wrapper);
      }
    }, true);

    container.addEventListener('click', (e) => {
      // Handle dropdown title clicks
      if (e.target.closest('.product__dropdown_title')) {
        triggerFaq(e.target.closest('.product__dropdown_title'));
        return;
      }

      // Handle continue button clicks
      const continueBtn = e.target.closest('.product__dropdown_button');
      if (continueBtn) {
        const wrapper = continueBtn.closest('.product__dropdown_wr');
        const inner = wrapper && wrapper.querySelector('.product__dropdown_inner');

        if (!wrapper || !inner) return;
        if (!validateStep(wrapper, true)) {
          updateContinueButton(wrapper);
          return;
        }

        wrapper.querySelectorAll('.error-message').forEach(el => el.style.display = 'none');
        wrapper.classList.remove('open');
        wrapper.classList.add('complete');
        inner.classList.remove('open');
        inner.classList.add('done', 'super_done');

        const nextWrapper = getNextDropdown(wrapper);
        if (nextWrapper) {
          nextWrapper.classList.add('open');
          nextWrapper.classList.remove('disabled');
          const nextInner = nextWrapper.querySelector('.product__dropdown_inner');
          nextInner.classList.add('open');
          nextInner.classList.remove('done');
          if (nextWrapper.getAttribute('data-dropdown') === 'mats_set_type') {
            filterZestawByBodyType();
          }
          // Extras — дополнительный шаг: снимаем disabled вместе с heel, но не раскрываем
          if (nextWrapper.classList.contains('product__dropdown_wr--heel')) {
            const extrasWr = nextWrapper.nextElementSibling;
            if (extrasWr && extrasWr.classList.contains('product__dropdown_wr--extras')) {
              extrasWr.classList.remove('disabled');
            }
          }

          const nextTitle = nextWrapper.querySelector('.product__dropdown_title');
          const popup = document.querySelector('#popupOverlayApplicationForm');
          const isInsidePopup = wrapper.closest('.popup');

          setTimeout(() => {
            if (nextTitle) {
              if (isInsidePopup) {
                popup.scrollTo({ top: nextTitle.offsetTop - 20, behavior: 'smooth' });
              } else {
                window.scrollTo({
                  top: nextTitle.getBoundingClientRect().top + window.scrollY - 350,
                  behavior: 'smooth'
                });
              }
            }
          }, 500);
        }

        if (container.querySelector('.application_form__next_button')) {
          updateNextButtonState(container);
        }
      }
    }, true);

    function getNextDropdown(current) {
      let next = current.nextElementSibling;
      while (next) {
        // Include extras: after heel Dalej must open Dodatkowe opcje (last config step)
        if (next.classList.contains('product__dropdown_wr')) {
          next.classList.remove('disabled');
          return next;
        }
        next = next.nextElementSibling;
      }
      return null;
    }

    var stepWrappers = Array.from(container.querySelectorAll('.product__dropdown_wr')).filter(function (w) {
      return !w.classList.contains('product__dropdown_wr--heel') && !w.classList.contains('product__dropdown_wr--extras');
    });
    stepWrappers.forEach(function (wrapper, i) {
      const title = wrapper.querySelector('.product__dropdown_title');
      if (title) title.innerHTML = (i + 1) + '. ' + title.innerHTML;
      if (i === 0) {
        wrapper.classList.add('open');
        var inner = wrapper.querySelector('.product__dropdown_inner');
        if (inner) inner.classList.add('open');
        wrapper.classList.remove('disabled');
      }
    });

    function updateNextButtonState(container) {
      const steps = container.querySelectorAll('.product__dropdown_wr');
      const nextButton = container.querySelector('.application_form__next_button');
      if (!steps.length || !nextButton) return;

      const allCompleted = [...steps].every(step => {
        if (step.classList.contains('product__dropdown_wr--heel') ||
            step.classList.contains('product__dropdown_wr--extras') ||
            !step.querySelector('.product__dropdown_button')) return true;
        return step.querySelector('.product__dropdown_inner')?.classList.contains('super_done');
      });

      nextButton.disabled = !allCompleted;
      nextButton.classList.toggle('disabled-button', !allCompleted);
    }

    function setFollowingStepsDisabled(currentWrapper, disabled) {
      let next = currentWrapper.nextElementSibling;
      while (next) {
        if (next.classList.contains('product__dropdown_wr') &&
            !next.classList.contains('product__dropdown_wr--heel') &&
            !next.classList.contains('product__dropdown_wr--extras')) {
          next.classList.toggle('disabled', disabled);
        }
        next = next.nextElementSibling;
      }
    }
  });

  // Фильтрация вариантов Zestaw по выбранному типу кузова (5os/7os): только display block/none
  function filterZestawByBodyType() {
    const yearWr = document.querySelector('[data-dropdown="year"]');
    const bodyTypeRadio = yearWr && yearWr.querySelector('input[name="properties[Typ nadwozia]"]:checked');
    const matsSetWr = document.querySelector('[data-dropdown="mats_set_type"]');
    const container = (matsSetWr && matsSetWr.closest('.config_container')) || document;
    const matsSet = container.querySelector('.product-form__input[data-name="mats_set"]');
    if (!matsSet) return;

    // Tear down temporary "Dodatkowe zestawy" dropdown if present
    const more = matsSet.querySelector('.evm-set-more');
    if (more) {
      const moreBody = more.querySelector('.evm-set-more__body') || more;
      while (moreBody.firstChild) matsSet.insertBefore(moreBody.firstChild, more);
      more.remove();
    }

    const inputs = matsSet.querySelectorAll('input[type="radio"]');
    if (!inputs.length) return;

    function norm(s) {
      return (s || '').trim().toLowerCase().replace(/\s+/g, ' ');
    }
    let selectedType = '';
    if (bodyTypeRadio) {
      selectedType = (bodyTypeRadio.getAttribute('data-body-type') || bodyTypeRadio.value || '').trim().toLowerCase();
      if (selectedType.includes('7os')) selectedType = '7os';
      else if (selectedType.includes('5os')) selectedType = '5os';
      else selectedType = '';
    }

    inputs.forEach(function (input) {
      const types = (input.getAttribute('data-body-types') || '').trim();
      const label = matsSet.querySelector('label[for="' + input.id + '"]') ||
        container.querySelector('label[for="' + input.id + '"]');
      if (!selectedType) {
        input.style.display = '';
        if (label) label.style.display = '';
        return;
      }
      const allowed = types.split(/\s+/).filter(Boolean).map(norm);
      const show = allowed.length === 0 || allowed.some(function (t) { return t === selectedType; });
      input.style.display = show ? '' : 'none';
      if (label) label.style.display = show ? '' : 'none';
    });

    const checked = matsSet.querySelector('input[type="radio"]:checked');
    if (checked && checked.style.display === 'none') {
      const firstVisible = Array.prototype.slice.call(inputs).find(function (inp) {
        return inp.style.display !== 'none';
      });
      if (firstVisible) {
        firstVisible.checked = true;
        matsSet.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Картинка по кузову: у видимых вариантов подставить data-image-5os / data-image-7os
    if (selectedType) {
      inputs.forEach(function (input) {
        if (input.style.display === 'none') return;
        const label = matsSet.querySelector('label[for="' + input.id + '"]') ||
          container.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        const img = label.querySelector('img[data-image-5os], img[data-image-7os]');
        if (!img) return;
        const src = img.getAttribute('data-image-' + selectedType);
        if (src) img.src = src;
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { filterZestawByBodyType(); });
  } else {
    filterZestawByBodyType();
  }

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-dropdown="year"] input[name="properties[Typ nadwozia]"]')) {
      filterZestawByBodyType();
      document.querySelectorAll('.product.config_container, .application_form__content.config_container').forEach(function (c) {
        if (window.evmUpdateMatImage) window.evmUpdateMatImage(c);
      });
    }
  }, true);

  // Year select handler - EVENT DELEGATION
  document.addEventListener('change', (e) => {
    const normalize = (str) => (str || '')
      .toString()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/ł/g, 'l')
      .replace(/Ł/g, 'l')
      .toLowerCase()
      .trim();

    const shouldHideHeelMount = (input) => {
      if (!input) return false;
      const selected = normalize(input.dataset.title || input.value || '');
      return (
        selected === 'tyl'
        || selected === 'bagaznik'
        || selected === 'mata do bagaznika'
        || selected === 'bagaznik maly'
        || selected === 'bagaznik duzy'
      );
    };

    const syncHeelMountGroupsVisibility = (input) => {
      const hideMount = shouldHideHeelMount(input);
      const heelMountGroups = document.querySelectorAll('.product__dropdown_wr--heel .option-group');
      if (!heelMountGroups.length) return;

      heelMountGroups.forEach((group) => {
        const groupName = normalize(group.getAttribute('data-group'));
        const isMountGroup = groupName === 'montaz' || groupName === 'montaz' || groupName === 'mount';
        if (!isMountGroup) return;

        group.style.display = hideMount ? 'none' : '';

        // If mounted surcharge was selected, switch to non-mounted when group becomes hidden.
        if (hideMount) {
          const activeBtn = group.querySelector('.product__upsell_item_variant.active');
          const hasMountedActive = activeBtn && /\+/.test(activeBtn.dataset.value || '');
          if (hasMountedActive) {
            const nonMountedBtn = Array.from(group.querySelectorAll('.product__upsell_item_variant'))
              .find((btn) => !/\+/.test(btn.dataset.value || ''));
            if (nonMountedBtn) nonMountedBtn.click();
          }
        }
      });
    };

    if (e.target.matches('[data-dropdown="year"] .select__select')) {
      const yearProperty = e.target.closest('.product__dropdown_wr').querySelector('.product__dropdown_value');
      if (yearProperty) {
        yearProperty.textContent = e.target.value;
      }
    }
    
    // Trunk label handler
    if (e.target.matches('[data-name="mats_set"] input')) {
      const labelTrunk = document.querySelector('.label_trunk');
      if (labelTrunk) {
        labelTrunk.classList.toggle('hidden', !e.target.classList.contains('input_trunk'));
      }
      syncHeelMountGroupsVisibility(e.target);
    }

    // Extras dropdown: update title value and .active на карточке
    var extrasWr = e.target.closest && e.target.closest('.product__dropdown_wr--extras');
    if (extrasWr && e.target.matches('input[name="product__extras"]')) {
      var item = e.target.closest('.product__upsell_item');
      if (item) {
        if (e.target.checked) item.classList.add('active');
        else item.classList.remove('active');
      }
      var valueEl = extrasWr.querySelector('.product__dropdown_value');
      if (valueEl) {
        var checked = extrasWr.querySelectorAll('input[name="product__extras"]:checked');
        valueEl.textContent = checked.length ? Array.from(checked).map(function (inp) { return inp.getAttribute('data-title') || inp.value; }).join(', ') : '';
      }
    }
  }, true);

  // Extras: клик по варианту — добавить .active и обновить value чекбокса (как в custom.js для heel)
  document.addEventListener('click', function (e) {
    if (!e.target.classList.contains('product__upsell_item_variant')) return;
    var extrasWr = e.target.closest('.product__dropdown_wr--extras');
    if (!extrasWr) return;
    var groupContainer = e.target.closest('.option-group');
    var item = e.target.closest('.product__upsell_item');
    if (!groupContainer || !item) return;
    var checkbox = item.querySelector('input[name="product__extras"]');
    var variantsJson = item.dataset.variants;
    if (!checkbox || !variantsJson) return;
    var variants = JSON.parse(variantsJson);
    groupContainer.querySelectorAll('.product__upsell_item_variant').forEach(function (el) { el.classList.remove('active'); });
    e.target.classList.add('active');
    var groups = item.querySelectorAll('.option-group');
    var selectedOptions = {};
    groups.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex, 10) + 1;
      var active = group.querySelector('.product__upsell_item_variant.active');
      if (active) selectedOptions['option' + idx] = active.dataset.value;
    });
    var matching = variants.find(function (v) {
      return Object.keys(selectedOptions).every(function (k) { return v[k] === selectedOptions[k]; });
    });
    if (matching) {
      checkbox.value = matching.id;
      checkbox.dataset.price = matching.price;
    }
  }, true);

  // Initialize trunk label
  const checkedInput = document.querySelector('[data-name="mats_set"] input:checked');
  const labelTrunk = document.querySelector('.label_trunk');
  if (checkedInput && labelTrunk) {
    labelTrunk.classList.toggle('hidden', !checkedInput.classList.contains('input_trunk'));
  }
  if (checkedInput) {
    const evt = new Event('change', { bubbles: true });
    checkedInput.dispatchEvent(evt);
  }
})();
